import { fetchApiStoresLean } from '../../util/api';
import { storableError } from '../../util/errors';

// ================ Action types ================ //

export const SET_INITIAL_STATE = 'app/DealersDirectoryPage/SET_INITIAL_STATE';

export const LOAD_DEALERS_REQUEST = 'app/DealersDirectoryPage/LOAD_DEALERS_REQUEST';
export const LOAD_DEALERS_SUCCESS = 'app/DealersDirectoryPage/LOAD_DEALERS_SUCCESS';
export const LOAD_DEALERS_ERROR = 'app/DealersDirectoryPage/LOAD_DEALERS_ERROR';

// ================ Reducer ================ //

const initialState = {
  dealers: [],
  dealersInProgress: false,
  dealersError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SET_INITIAL_STATE:
      return { ...initialState };
    case LOAD_DEALERS_REQUEST:
      return {
        ...state,
        dealersInProgress: true,
        dealersError: null,
      };
    case LOAD_DEALERS_SUCCESS:
      return {
        ...state,
        dealersInProgress: false,
        dealers: payload.dealers,
      };
    case LOAD_DEALERS_ERROR:
      return {
        ...state,
        dealersInProgress: false,
        dealersError: payload,
      };
    default:
      return state;
  }
}

// ================ Selectors ================ //

export const selectDealersDirectoryPage = state => state.DealersDirectoryPage;

export const selectDealers = state => {
  const { dealers } = selectDealersDirectoryPage(state);
  return dealers;
};

export const selectDealersInProgress = state => {
  const { dealersInProgress } = selectDealersDirectoryPage(state);
  return dealersInProgress;
};

export const selectDealersError = state => {
  const { dealersError } = selectDealersDirectoryPage(state);
  return dealersError;
};

// ================ Action creators ================ //

export const setInitialState = () => ({
  type: SET_INITIAL_STATE,
});

export const loadDealersRequest = () => ({
  type: LOAD_DEALERS_REQUEST,
});

export const loadDealersSuccess = dealers => ({
  type: LOAD_DEALERS_SUCCESS,
  payload: { dealers },
});

export const loadDealersError = error => ({
  type: LOAD_DEALERS_ERROR,
  payload: error,
});

// ================ Thunks ================ //

export const loadDealers = () => (dispatch, getState) => {
  dispatch(loadDealersRequest());

  return fetchApiStoresLean()
    .then(response => {
      const dealers = response?.data?.data || [];
      dispatch(loadDealersSuccess(dealers));
      return dealers;
    })
    .catch(error => {
      const err = storableError(error);
      dispatch(loadDealersError(err));
      throw err;
    });
};

// ================ Export ================ //

export const loadData = (params, search, config) => (dispatch, getState, sdk) => {
  return dispatch(loadDealers());
};
